import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Initialize our database
import { initializeDatabase } from './db';
console.log('DEBUG: src/index.css imported in src/index.js');

// Initialize the in-memory database
initializeDatabase();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// We've removed reportWebVitals() call until it's needed

// Disable service worker to prevent reload loops
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.getRegistrations()
      .then((registrations) => {
        registrations.forEach((registration) => registration.unregister());
      })
      .catch((error) => {
        console.error('Service Worker cleanup failed:', error);
      });
  });
}